import React, { FC } from 'react'
import _AutoSizer from "react-virtualized-auto-sizer"

type AutoSizerProps = {
    children: ({ width, height }:{ width: number, height: number })=>React.ReactNode
}

export const AutoSizer = _AutoSizer as unknown as FC<AutoSizerProps>